// @flow
import React from 'react';
import {SkipToContentMenuAnchor} from '@homeaway/react-skip-to-content-menu';
import {injectIntl} from 'react-intl';

import type {IntlShape} from 'react-intl';

type Props = {
    menuItemLabel?: string,
    anchorLabel?: string,
    id: string,
    intl: IntlShape
};

const ConnectedSkipToContentAnchor = ({
    menuItemLabel,
    anchorLabel,
    id,
    intl
}: Props) => {
    const {formatMessage} = intl;
    const skipToContentProps = {
        id,
        menuItemLabel: menuItemLabel || formatMessage({id, defaultMessage: id}),
        anchorLabel:
            anchorLabel ||
            formatMessage({id: `${id}.anchorLabel`, defaultMessage: id})
    };
    return <SkipToContentMenuAnchor {...skipToContentProps} />;
};

export default injectIntl(ConnectedSkipToContentAnchor);
